import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

// Landing point after Emergent Google OAuth: `{origin}/dashboard#session_id=...`
export default function GoogleAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId })
      .then(({ data }) => {
        loginWithToken(data.access_token, data.user);
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        navigate("/login", {
          replace: true,
          state: { googleError: err.response?.data?.detail || "Google sign-in failed. Please try again." },
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center gap-4" data-testid="google-auth-callback">
      <div className="spinner"></div>
      <p className="text-[#A1A1AA] text-sm">Signing you in with Google...</p>
    </div>
  );
}
